// Activate sticky header on scroll
window.onscroll = function () {
	console.log('Main started');
	stickyHeaderOnScroll();
};


// Headers
const header = document.querySelector(".header");
const headerTop = document.querySelector(".header__top");
const headerNav = document.querySelector(".header__nav");
const headerMenu = document.querySelector(".header__menu");

let offset = header.offsetTop;

// Header sizes
let headerTopHeight = headerTop.offsetHeight;
// let headerHeight = header.offsetHeight;

// Mobile toggle
const mobileToggle = document.querySelector(".mobile-toggle");
console.log(mobileToggle);
/**
 * 
 * Handle sticky header scroll behavior
 *
 */
function stickyHeaderOnScroll() {

  //if mobile or touch device
  if (getDeviceType()== 'mobile' || getDeviceType()== 'tablet') {
    if (window.pageYOffset > offset) {
      header.classList.add("header-has-scrolled");
      header.classList.add("header-has-sticky");
      header.classList.add("header-sticky");
    } else {
      header.classList.remove("header-has-scrolled");
      header.classList.remove("header-has-sticky");
      header.classList.remove("header-sticky");
    }
  }

  // if desktop 
  else if(getDeviceType()=='desktop') {

    if (window.pageYOffset > offset) {
      header.classList.add("header-has-scrolled");
    } else {
      header.classList.remove("header-has-scrolled");
    }
    
    if (window.pageYOffset > headerTopHeight) {
      // headerMain.classList.add("header-sticky");
      // header.classList.add("header-has-sticky");
      header.classList.add("header-sticky");
    } else {
	    header.classList.remove("header-sticky");
    }
  }
};

/**
 * 
 * Mobile menu toggle
 *
 */
mobileToggle.addEventListener("click", () => {

	headerNav.classList.toggle("menu-open");
	header.classList.toggle("has-open-menu");
  mobileToggle.classList.toggle("is-active");

	console.log("clicked");
});

const expandBtn = document.querySelectorAll(".header__menu__btn");

expandBtn.forEach((btn) => {
	
	btn.addEventListener("click", () => {

		btn.classList.toggle("expanded");
	});
});

// window.screen.availWidth; // 1440

const getDeviceType = () => {
  const ua = navigator.userAgent;
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
    return "tablet";
  }
  if (
    /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
      ua
    )
  ) {
    return "mobile";
  }
  return "desktop";
};